<template>
  <v-card
  >
    <v-list>
      <v-list-item
        v-for="(whats, i) in fornecedorEnvio.whatsapps"
        :key="i"
        :value="whats"
        color="primary"
      >
        <v-list-item-title>
          {{ whats | phone | naoInformado }}
        </v-list-item-title>
        <v-list-item-action v-if="hasModuleGerencia">
          <v-btn icon small @click="remove(whats)">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="!fornecedorEnvio.whatsapps.length">
        <v-list-item-title class="texto">
          Nenhum whatsapp encontrado
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  props: {
    hasModuleGerencia: Boolean,
    fornecedor: Object,
  },
  data() {
    return {
      fornecedorEnvio: {
        whatsapps: [],
      },
    };
  },
  methods: {
    remove(item) {
      const fornecedor = { ...this.fornecedorEnvio };
      fornecedor.whatsapps = fornecedor.whatsapps.filter(
        whats => whats !== item,
      );
      this.save(fornecedor);
    },
    save(fornecedor) {
      GestaoFornecedorService.updateWhatsapp(this.fornecedor.id, fornecedor)
        .then(() => {
          this.$toast('Whatsapp removido', { color: 'success' });
          this.getWhatsapps();
        });
    },
    getWhatsapps() {
      GestaoFornecedorService.get(this.fornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedorEnvio.whatsapps = fornecedor.whatsapps || [];
        });
    },
  },
  created() {
    this.getWhatsapps();
  },
};
</script>
<style scoped>
.texto{
  font-size: 0.9rem;
}

</style>
